module.exports = __webpack_public_path__ + "static/media/goblin_helmet.dc3c9564.png";